/*
 * Eigene Such-Vorschlaege (Autosuggest) fuer die Suchfelder im Shop (Kopfzeile + Suchseite).
 * Shopifys Standard-Vorschlaege kennen nur das Platzhalter-Produkt "Dein individuelles Shirt" - Produkte, Motive und Themen
 * liegen bei uns: https://shirtracer.de/api/suche?q=... (packages/server/src/apiServer.ts).
 * Wir fangen das input-Ereignis vor Shopifys <predictive-search> ab und fuellen dessen Ergebnis-Container selbst.
 */
(function () {
  var API = "https://shirtracer.de/api/suche?q=";
  var WARTEZEIT = 220, MIN_ZEICHEN = 2;
  var zaehler = 0, timer = null;

  function esc(t) { return String(t).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); }
  function euro(n) { return n.toFixed(2).replace(".", ",") + " €"; }

  var css = document.createElement("style");
  css.textContent =
    ".sr-vorschlag{padding:8px 4px 12px;text-align:left;}" +
    ".sr-vorschlag__titel{margin:10px 12px 6px;font-size:1.2rem;letter-spacing:.08em;text-transform:uppercase;color:#6b6460;}" +
    ".sr-vorschlag__liste{list-style:none;margin:0;padding:0;}" +
    ".sr-vorschlag__zeile{display:flex;align-items:center;gap:12px;padding:8px 12px;text-decoration:none;color:inherit;border-radius:6px;}" +
    ".sr-vorschlag__zeile:hover,.sr-vorschlag__zeile:focus{background:#f3eeeb;}" +
    ".sr-vorschlag__bild{flex:0 0 48px;width:48px;height:48px;border-radius:4px;background:#f3f1f2;display:flex;align-items:center;justify-content:center;overflow:hidden;}" +
    ".sr-vorschlag__bild img{width:100%;height:100%;object-fit:contain;}" +
    ".sr-vorschlag__name{display:block;font-size:1.4rem;line-height:1.3;}" +
    ".sr-vorschlag__preis{display:block;color:#902342;font-weight:700;font-size:1.25rem;}" +
    ".sr-vorschlag__chips{display:flex;flex-wrap:wrap;gap:8px;padding:2px 12px 4px;}" +
    ".sr-vorschlag__chip{border:1px solid #d9d9de;border-radius:999px;padding:5px 13px;font-size:1.3rem;text-decoration:none;color:inherit;}" +
    ".sr-vorschlag__chip:hover{border-color:#902342;color:#902342;}" +
    ".sr-vorschlag__motive{display:flex;gap:8px;padding:2px 12px 4px;}" +
    ".sr-vorschlag__motive a{flex:1 1 0;max-width:25%;aspect-ratio:1/1;background:#f3f1f2;border-radius:4px;overflow:hidden;display:block;}" +
    ".sr-vorschlag__motive img{width:100%;height:100%;object-fit:contain;}" +
    ".sr-vorschlag__alle{display:block;margin:8px 12px 2px;padding:10px;text-align:center;background:#902342;color:#fff;border-radius:999px;text-decoration:none;font-weight:700;font-size:1.35rem;}" +
    ".sr-vorschlag__leer{padding:14px 12px;font-size:1.4rem;color:#6b6460;}";
  document.head.appendChild(css);

  function hole(eingabe) {
    var wrapper = eingabe.closest("predictive-search");
    if (!wrapper) return null;
    return { wrapper: wrapper, box: wrapper.querySelector("[data-predictive-search]") };
  }
  function oeffnen(ziel, eingabe) {
    ziel.wrapper.setAttribute("open", "");
    eingabe.setAttribute("aria-expanded", "true");
  }
  function schliessen(ziel, eingabe) {
    if (!ziel) return;
    ziel.wrapper.removeAttribute("open");
    if (eingabe) eingabe.setAttribute("aria-expanded", "false");
  }

  function zeichne(daten, begriff) {
    var p = (daten.produkte || []).slice(0, 4), m = (daten.motive || []).slice(0, 4), t = (daten.themen || []).slice(0, 3);
    if (!p.length && !m.length && !t.length) {
      return '<div class="sr-vorschlag"><p class="sr-vorschlag__leer">Keine Treffer für „' + esc(begriff) + '“. Probiere einen anderen Begriff.</p></div>';
    }
    var h = '<div class="sr-vorschlag">';
    if (p.length) {
      h += '<p class="sr-vorschlag__titel">Produkte</p><ul class="sr-vorschlag__liste">' + p.map(function (x) {
        return '<li><a class="sr-vorschlag__zeile" href="' + esc(x.url) + '"><span class="sr-vorschlag__bild">' +
          (x.bild ? '<img src="' + esc(x.bild) + '" alt="" loading="lazy" width="48" height="48">' : "") + '</span><span><span class="sr-vorschlag__name">' + esc(x.name) + "</span>" +
          (x.preis ? '<span class="sr-vorschlag__preis">ab ' + euro(x.preis) + "</span>" : "") + "</span></a></li>";
      }).join("") + "</ul>";
    }
    if (t.length) {
      h += '<p class="sr-vorschlag__titel">Themen</p><div class="sr-vorschlag__chips">' + t.map(function (x) {
        return '<a class="sr-vorschlag__chip" href="' + esc(x.url) + '">' + esc(x.name) + "</a>";
      }).join("") + "</div>";
    }
    if (m.length) {
      h += '<p class="sr-vorschlag__titel">Motive</p><div class="sr-vorschlag__motive">' + m.map(function (x) {
        return '<a href="' + esc(x.url) + '" title="' + esc(x.name) + '"><img src="' + esc(x.bild) + '" alt="' + esc(x.name) + '" loading="lazy" width="80" height="80"></a>';
      }).join("") + "</div>";
    }
    h += '<a class="sr-vorschlag__alle" href="/search?q=' + encodeURIComponent(begriff) + '">Alle Ergebnisse für „' + esc(begriff) + "“</a></div>";
    return h;
  }

  // In der Erfassungsphase vor Shopifys eigenem input-Handler laufen und diesen unterdruecken
  document.addEventListener("input", function (e) {
    var eingabe = e.target;
    if (!eingabe || !eingabe.matches || !eingabe.matches("input.search__input")) return;
    var ziel = hole(eingabe);
    if (!ziel || !ziel.box) return;
    e.stopImmediatePropagation();

    var begriff = eingabe.value.trim();
    clearTimeout(timer);
    if (begriff.length < MIN_ZEICHEN) { schliessen(ziel, eingabe); return; }
    var nr = ++zaehler;
    timer = setTimeout(function () {
      fetch(API + encodeURIComponent(begriff))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (nr !== zaehler) return; // veraltete Antwort
          ziel.box.innerHTML = zeichne(d, begriff);
          oeffnen(ziel, eingabe);
        })
        .catch(function () { /* ohne Vorschlaege weitersuchen (Enter) */ });
    }, WARTEZEIT);
  }, true);

  // Shopifys Fokus-/Fokusverlust-Handler wuerden unser Fenster sonst leeren oder schliessen
  document.addEventListener("focusin", function (e) {
    var el = e.target;
    if (el && el.matches && el.matches("input.search__input")) {
      var ziel = hole(el);
      if (ziel && ziel.box && ziel.box.querySelector(".sr-vorschlag") && el.value.trim().length >= MIN_ZEICHEN) { e.stopImmediatePropagation(); oeffnen(ziel, el); }
    }
  }, true);
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    document.querySelectorAll("predictive-search[open]").forEach(function (w) { w.removeAttribute("open"); });
  });
  document.addEventListener("click", function (e) {
    document.querySelectorAll("predictive-search[open]").forEach(function (w) { if (!w.contains(e.target)) w.removeAttribute("open"); });
  });
})();
